
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";

import { MessageBox } from "element-ui";
import enumFilter from "@/mixins/filters/enums";

import { ProtocolDto } from "@/api/appService";

let isShow: boolean = true;

import EditProtocol from "./components/edit-protocol.vue";
import ProtocolDetail from "./components/protocol-detail.vue";
import OrganizationUnitQuerySelect from "@/components/OrganizationUnitQuerySelect/index.vue";
import PagedTableView from "@/components/PagedTableView/index.vue";

@Component({
  name: "protocolList",
  components: {
    PagedTableView,
    OrganizationUnitQuerySelect,
    EditProtocol,
    ProtocolDetail
  },
  mixins: [enumFilter]
})
export default class protocolList extends Vue {
  tableItems: ProtocolDto[] = [];
  detail: any = {};
  dialogShow = false;
  attachments: any = []; // 附件数组
  newAttachments: any = []; // 附件id数组
  type: any; // 协议类型 1：合伙人协议 2：社区委托运营协议 3：其他合同



  @Watch("$route")
  routechange(to: any, from: any) {
    console.log("检测到路由变化：");
    console.log(to);
    console.log(from);
    this.typeChange();
    this.resetForm();
    this.$nextTick(()=>{
      (this.$refs.pagedTableView as any).refreshData();
    });

  }

  queryForm: any = {
    keyword: "",
    displayName: "",
    cooperationPeriod: "",
    signingDate: "",
    organizationUnitId:undefined,
    type:0
  };

  async created(){
    this.typeChange()
  }

  typeChange(){
    let type:string;
    let typeFromUrl = this.getTypeFromPath();
    if(typeFromUrl && typeFromUrl.length>0){
      type = typeFromUrl[0];
    } else {
      type = '';
    }
    if(type){
      this.type = type;
      this.queryForm.type = this.type;
    } else{
      this.$message.error('无法从url中识别type参数，您接下来的操作将无法继续执行')
    }

  }

  getTypeFromPath(){
    return /(\d+)$/.exec(this.$route.path);
  }

  resetForm(){
    this.queryForm.organizationUnitId = 'All';
    this.queryForm.cooperationPeriod = '';
    this.queryForm.displayName = '';
    this.queryForm.keyword = '';
    this.queryForm.signingDate = '';
  }

  // 获取表数据
  async fetchData(params:any) {
    return api.protocol.getAll(params);
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }

  handleView(e: any) {
    (this.$refs.detailDialog as any).show = true;
    this.detail = e;
  }

  // 编辑
  handleEdit(index: number, row: any) {
    (this.$refs.editForm as any).show = true;
    this.attachments = [];
    this.newAttachments = [];
    if (row.attachments.length > 0) {
      row.attachments.forEach((r: any) => {
        this.attachments.push({
          fileName: r.fileName,
          name: r.fileName,
          url: r.url,
          id: r.id
        });
        this.newAttachments.push(r.id);
      });
    }
    row.attachments = this.attachments;
    row.newAttachments = this.newAttachments;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: ProtocolDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.protocol
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
    });
  }

  // 下载附件
  async handleDownload(row: any) {
    if (row.attachments.length > 0) {
      row.attachments.forEach((r: any) => {
        api.attachment.download(r.id);
      });
    }
  }



}
